module.exports = __webpack_public_path__ + "kz.svg?6108408d532ee6f789944ef92e395f4f";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/kz.svg
// module id = 1107
// module chunks = 27